
var carouselLess = {};
import genaration from '../../utils/classname';
export var carouselClass = genaration(carouselLess, 'carousel');